import { RatingTypeProps } from './TypeProps';
import IconRating from './rating.svg';
import classNames from 'classnames';

import styles from './Rating.module.scss';

export const Rating = ({ rating, className }: RatingTypeProps) => {
  return (
    <div className={classNames(styles.Container, className)}>
      <IconRating width={34} height={22} />
      <span className={styles.Rating}>{parseFloat(rating).toFixed(1)}</span>
    </div>
  );
};
